import ProductsPage from './ProductsPage';
import productsPageReducer from './reducer';

export { productsPageReducer };
export default ProductsPage;
